import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router";
import {getCampaignBySlug, saveCampaign} from "@/api/CampaignApi.ts";
import Campaign from "@/campaigns/model/Campaign.ts";
import CampaignForm from "@/admin/campaigns/form/CampaignForm.tsx";
import Error404 from "@/Error404.tsx";
import type {SaveCampaignRequest} from "@/api/CampaignApi.ts";

export default function CampaignEditView() {
    const {campaignSlug = ""} = useParams();
    const navigate = useNavigate();
    const [campaign, setCampaign] = useState<Campaign>();
    const [missing, setMissing] = useState(false);

    useEffect(() => {
        let cancelled = false;
        getCampaignBySlug(campaignSlug)
            .then(value => {
                if (!cancelled) setCampaign(value);
            })
            .catch(() => {
                if (!cancelled) setMissing(true);
            });
        return () => { cancelled = true; };
    }, [campaignSlug]);

    if (missing) return <Error404/>;
    if (!campaign) return <p role="status" className="p-6">Kampagne wird geladen…</p>;

    return <>
        <title>{`${campaign.title} bearbeiten | DireDawn`}</title>
        <CampaignForm key={campaign.id} defaultValue={campaign} onSubmit={async (value: SaveCampaignRequest) => {
            const saved = await saveCampaign(value);
            setCampaign(saved);
            navigate(`/admin/campaigns/${saved.slug}`, {replace: true});
            return saved;
        }}/>
    </>;
}
